<template>
  <div class="City" v-if="city">
    <vue-headful :title="title | truncate(60)" :description="metaDescription" :url="url" />
    <SeoSchema :json="city.seo_schema" />
    <CityHeader
      v-if="city"
      :Counties="city.counties"
      :Breadcrumbs="this.Breadcrumbs"
      :ImageCredit="city.imageCredit"
      :Title="city.name"
      :Region="city.region"
      :Description="city.description"
      :Image="city.imageUrl"
      :Photos="city.photos"
      :ImageAlt="city.name"
      Location="cityPage"
    />

    <InsidersGuide
      v-if="city && city.insiders && city.insiders.description"
      :description="city.insiders.description"
      :headline="city.insiders_headline"
      :cityname="city.name"
      :cityId="city.id.toString()"
      :image="city.insiders.imageUrl"
      :linkText="city.insiders_guide_link_text"
      :link="city.insiders_url"
      :imageDescription="city.insiders_image_description"
    />
    <Quote v-if="city && city.insiders_quote" :quote="city.insiders_quote" />
    <ExploreCity v-if="city && this.articles" :cityName="city.name" :articles="this.articles" />
    <div v-if="city" class="container-fluid places-you-may-like">
      <div class="carousel-row">
        <h2 class="header">Places Around {{ city.name }} You May Like</h2>
        <PlacesToGoCarousel
          v-if="accommodationsToPass && accommodationsToPass.length > 0"
          :myTrips="this.trips"
          words="Where to Stay"
          :items="accommodationsToPass"
          :defaultImage="defaultHotelImage"
          :sliderCount="carouselsToDisplay"
        />
        <PlacesToGoCarousel
          v-if="doToPass && doToPass.length > 0"
          :myTrips="this.trips"
          words="What to See & Do"
          :items="doToPass"
          :defaultImage="defaultAttractionImage"
          :sliderCount="carouselsToDisplay"
        />
        <PlacesToGoCarousel
          v-if="eatsToPass && eatsToPass.length > 0"
          :myTrips="this.trips"
          words="Where to Eat"
          :items="eatsToPass"
          :defaultImage="defaultFoodImage"
          :sliderCount="carouselsToDisplay"
        />
      </div>
    </div>
    <UpcomingEvents
      v-if="city && this.events"
      :defaultSearch="city.area"
      :citySlug="city.slug"
      :area="city.area"
      :cityId="city.id"
      :cityName="city.name"
      :events="this.events"
    />
    <!-- <TripIdeas class="pt-5" /> -->
    <Crowdriff
      v-if="city && city.crowdriff_id"
      :id="city.crowdriff_id"
      :aria-label="page.fields.crowdriff_gallery.aria_label"
      :title="page.fields.crowdriff_gallery.title"
      :intro="page.fields.crowdriff_gallery.intro"
    />
    <HowToGetThere
      v-if="city && city.directions && city.directions.car"
      :travelOptions="city.directions"
    />
    <AttractionFilter
      v-if="city && city.area"
      :defaultSearch="city.area"
      :citySlug="city.slug"
      :area="city.area"
    />

    <Feedback v-if="city" pageType="listing" />
    <Footer />
  </div>
</template>

<script>
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import Butter from 'buttercms';
import axios from 'axios';
import { Auth } from 'aws-amplify';
import CityHeader from '@/components/PlacesToGo/Common/CityHeader.vue';
import PlacesToGoCarousel from '@/components/PlacesToGo/Cities/places-to-go-carousel.vue';
import TripIdeas from '@/components/PlacesToGo/Common/TripIdeas.vue';
import InsidersGuide from '@/components/PlacesToGo/Cities/InsidersGuide.vue';
import AttractionFilter from '@/components/PlacesToGo/Common/AttractionFilter.vue';
import Quote from '@/components/PlacesToGo/Cities/Quote.vue';
import UpcomingEvents from '@/components/PlacesToGo/Cities/UpcomingEvents.vue';
import ExploreCity from '@/components/PlacesToGo/Cities/ExploreCity.vue';
import Crowdriff from '@/components/Common/Crowdriff.vue';
import HowToGetThere from '@/components/PlacesToGo/Common/HowToGetThere.vue';
import Footer from '@/components/Common/Footer.vue';

export const butter = Butter('eb418357164849860c223876bb84811162582149');

@Component({
  data() {
    return {
      defaultHotelImage: '/images/misc/hotel-no-image.png',
      defaultAttractionImage: '/images/misc/attraction-no-image.png',
      defaultFoodImage: '/images/misc/food-no-image.png',
      title: '',
      metaDescription: '',
      url: '',
      trips: [],
      articles: [],
      events: [],
    };
  },
  components: {
    CityHeader,
    PlacesToGoCarousel,
    TripIdeas,
    InsidersGuide,
    UpcomingEvents,
    HowToGetThere,
    Footer,
    Quote,
    AttractionFilter,
    Crowdriff,
    ExploreCity,
  },
  async created() {
    await this.GetCityDetails();
    await this.getPage();
    await this.getArticles();
    await this.getEvents();
  },
  computed: {
    carouselsToDisplay() {
      let display = 0;
      if (this.accommodationsToPass && this.accommodationsToPass.length > 0) {
        display++;
      }
      if (this.doToPass && this.doToPass.length > 0) {
        display++;
      }
      if (this.eatsToPass && this.eatsToPass.length > 0) {
        display++;
      }
      return display;
    },
  },
})
class City extends Vue {
  @Watch('id', { immediate: true, deep: true })
  async onCityChanged() {
    await this.GetCityDetails();
    await this.getArticles();
    await this.getEvents();
  }

  @Prop({
    type: [Number, String],
    required: true,
  })
  id;

  city = null;

  accommodationsToPass = null;

  doToPass = null;

  eatsToPass = null;

  async getTrips() {
    try {
      const user = await Auth.currentAuthenticatedUser({ bypassCache: true });
      const response = await axios.get(
        `${process.env.VUE_APP_API2}visitors/${user.username}/trips`,
        {
          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${user.signInUserSession.idToken.jwtToken}`,
          },
        },
      );
      this.isLoggedIn = true;
      this.trips = response.data;
    } catch (error) {
      this.isLoggedIn = false;
      this.trips = [];
    }
  }

  async GetCityDetails() {
    await this.getTrips();
    await this.$store.dispatch('maps/setExperienceType', '');
    this.city = this.$store.getters['cities/getCityBySlug'](this.id);

    if (!this.city || !this.city.area) {
      await this.$store.dispatch('cities/getCity', this.id);
      this.city = this.$store.getters['cities/getCityBySlug'](this.id);
    }
    this.title = `${this.city.seo_title}`;
    this.metaDescription = `${this.city.seo_meta_description}`;

    this.url = `https://alabama.travel${this.$router.currentRoute.fullPath}`;
    await this.GetCityHotelsAndAttractions();
  }

  async getPage() {
    await butter.page
      .retrieve('*', 'city', {
        preview: `${process.env.VUE_APP_BUTTER_PREVIEW}`,
      })
      .then((res) => {
        this.page = res.data.data;
        this.isLoaded = true;
      })
      .catch((res) => {
        console.log(res);
      });
  }

  async getArticles() {
    await butter.tag
      .retrieve([this.city.slug], {
        include: 'recent_posts',
        preview: `${process.env.VUE_APP_BUTTER_PREVIEW}`,
      })
      .then((res) => {
        this.articles = res.data.data.recent_posts;
      })
      .catch((res) => {
        console.log(res);
      });
  }

  async getEvents() {
    const defaultSearchString = `cityId=${this.city.slug}&limit=20`;

    let events = [];
    try {
      await axios
        .get(`${process.env.VUE_APP_API2}searchEvents?${defaultSearchString}`, {
          headers: {
            'Access-Control-Allow-Origin': '*',
            Accept: 'application/json',
          },
        })
        .then((response) => {
          events = response.data.events.slice(0, 6);
        });
    } catch (error) {
      console.log(error);
    }

    this.events = events;
    console.log(this.Events);
  }

  async GetCityHotelsAndAttractions() {
    await axios
      .get(
        `${process.env.VUE_APP_API2}filterLocations?location_types=accommodation&limit=10&cityId=${this.id}`,
        {
          headers: {
            'Access-Control-Allow-Origin': '*',
            Accept: 'application/json',
          },
        },
      )
      .then((response) => {
        this.accommodationsToPass = response.data.locations;
      });
    await axios
      .get(
        `${process.env.VUE_APP_API2}filterLocations?location_types=attraction,retail,shoppingDestination,venue,service&limit=10&cityId=${this.id}`,
        {
          headers: {
            'Access-Control-Allow-Origin': '*',
            Accept: 'application/json',
          },
        },
      )
      .then((response) => {
        this.doToPass = response.data.locations;
      });
    await axios
      .get(
        `${process.env.VUE_APP_API2}filterLocations?location_types=food&limit=10&cityId=${this.id}`,
        {
          headers: {
            'Access-Control-Allow-Origin': '*',
            Accept: 'application/json',
          },
        },
      )
      .then((response) => {
        this.eatsToPass = response.data.locations;
      });
  }

  get Breadcrumbs() {
    return [
      {
        text: 'Places To Go',
        href: '/places-to-go',
      },
      {
        text: 'Cities & Towns',
        href: '/places-to-go/cities-and-towns',
      },
      {
        text: this.city.name,
        active: true,
      },
    ];
  }
}

export default City;
</script>

<style>
.places-you-may-like {
  background-color: #f9f9f9;
}
.carousel-row {
  max-width: 1450px;
  display: grid;
  grid-template-columns: repeat(12, minmax(0, 1fr));
  gap: 2rem;
  margin: 0 auto;
  padding: 3rem 0rem 9rem 0rem;

  @media only screen and (max-width: 998px) {
    grid-template-columns: repeat(1, minmax(0, 1fr));
    padding: 3rem 0rem 3rem 0rem;
  }
}
.header {
  grid-column: span 12 / span 12;
  max-width: 26rem;
  margin: 0 auto 2.5rem auto;
  @media only screen and (max-width: 998px) {
    grid-column: span 1 / span 1;
    margin: 0 auto 0 auto;
  }
}
</style>
